import { ErrorBoundary } from 'react-error-boundary';
import { SocialMedia } from '../SocialMedia';
import { AppDownload } from './app-download/AppDownload';
import { logoPng } from '../../../common';

export function RecommendInfo() {
  return (
    <div className="tlw-hidden tlw-flex-col-reverse md:tlw-flex md:tlw-gap-5 lg:tlw-flex-col lg:tlw-justify-between lg:tlw-gap-y-14">
      <div>
        <ErrorBoundary fallback={<div>AppDownload</div>}>
          <AppDownload />
        </ErrorBoundary>

        <ErrorBoundary fallback={<div>SocialMedia</div>}>
          <SocialMedia className="lg:tlw-mt-10" />
        </ErrorBoundary>
      </div>

      <ErrorBoundary fallback={<div>Logo</div>}>
        {logoPng && (
          <img className="tlw-w-[87px] tlw-h-[84px]" src={logoPng} alt="" />
        )}
      </ErrorBoundary>
    </div>
  );
}
